import { render, staticRenderFns } from "./ProductPricingDialogue.vue?vue&type=template&id=ebf93612&"
import script from "./ProductPricingDialogue.vue?vue&type=script&lang=ts&"
export * from "./ProductPricingDialogue.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports